import {Locale} from '../RootProvider/LocaleContext';

export const localesWithDashboard: Locale[] = [Locale.uk];
export const isLocaleWithDashboard = (locale: Locale): boolean => {
  return localesWithDashboard.includes(locale);
};
